import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/(redirects)/settings')({
  component: () => <Navigate to="/account" />,
});
